export const MODES = {
  SELECTED_ITEMS: 'selectedItems',
  ALL_ITEMS: 'allItems',
}
